import { ACCEPTANCE_OF_TERMS_HREF, PRIVACY_HREF } from './term-of-services-hrefs';

export const HOME_PAGE_PREFIX_KEY = 'home';
export const JOIN_PAGE_PREFIX_KEY = 'join';
export const SITE_PAGE_PREFIX_KEY = 'landing';
export const JOIN_AS_EXPERT_PREFIX_KEY = 'join_as_expert';
export const ABOUT_PAGE_PREFIX_KEY = 'about';
export const PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY = 'partnership_and_licensing';
export const VOLUNTEER_CONTENT_PAGE_PREFIX_KEY = 'volunteer_content';
export const SUPPORTING_CHARITIES_PAGE_PREFIX_KEY = 'supporting_charities';
export const NOTFOUND_PAGE_PREFIX_KEY = 'errors';
export const SIGN_UP_PAGE_PREFIX_KEY = 'sign_up';
export const HEADER_AND_FOOTER_PREFIX_KEY = 'header_and_footer';
export const ACCOUNT_SETTINGS_PREFIX_KEY = 'account_settings';
export const EXPERT_SETTINGS_PREFIX_KEY = 'expert_settings';
export const ONBOARDING_PAGE_PREFIX_KEY = 'onboarding';
export const SEARCH_PAGE_PREFIX_KEY = 'search_page';
export const TERM_OF_SERVICE_PREFIX_KEY = 'terms';
export const FAQ_PREFIX_KEY = 'faq';
export const EXPERT_FAQ_PREFIX_KEY = 'expert_faq';
export const USER_FAQ_PREFIX_KEY = 'user_faq';
export const EVENTS_PREFIX_KEY = 'events';
export const HEADER_AND_FOOTER_ADDITIONAL_BUTTONS_PREFIX_KEY = 'header_and_footer.additional_buttons';
export const HEADER_AND_FOOTER_ORGANIZATION_PREFIX_KEY = 'header_and_footer.footer.organization';
export const HEADER_AND_FOOTER_HORIZONTAL_NAV_PREFIX_KEY = 'header_and_footer.horizontal_nav';
export const HEADER_AND_FOOTER_SIDEBAR_PREFIX_KEY = 'header_and_footer.sidebar_menu_items';
export const HEADER_SITE_LOGO_KEY = 'header_and_footer.site_logo';
export const HEADER_STACKED_LOGO_KEY = 'header_and_footer.stacked_logo';

export const HOME_PAGE_KEYS = [
  `${HOME_PAGE_PREFIX_KEY}.top_section`,
  `${HOME_PAGE_PREFIX_KEY}.top_section.rotating_word`,
  `${HOME_PAGE_PREFIX_KEY}.what_is_sidetime`,
  `${HOME_PAGE_PREFIX_KEY}.highlight_sentence.desktop.1`,
  `${HOME_PAGE_PREFIX_KEY}.highlight_sentence.desktop.2`,
  `${HOME_PAGE_PREFIX_KEY}.highlight_sentence.mobile.1`,
  `${HOME_PAGE_PREFIX_KEY}.highlight_sentence.mobile.2`,
  `${HOME_PAGE_PREFIX_KEY}.highlight_sentence.mobile.3`,
  `${HOME_PAGE_PREFIX_KEY}.highlight_sentence.mobile.4`,
  `${HOME_PAGE_PREFIX_KEY}.how_it_works.1.step_title`,
  `${HOME_PAGE_PREFIX_KEY}.how_it_works.2.step_title`,
  `${HOME_PAGE_PREFIX_KEY}.how_it_works.3.step_title`,
  `${HOME_PAGE_PREFIX_KEY}.how_it_works.1`,
  `${HOME_PAGE_PREFIX_KEY}.how_it_works.2`,
  `${HOME_PAGE_PREFIX_KEY}.how_it_works.3`,
  `${HOME_PAGE_PREFIX_KEY}.charities_section`,
  `${HOME_PAGE_PREFIX_KEY}.charities_section.button`,
  `${HOME_PAGE_PREFIX_KEY}.charities_section.featured_donor`,
  `${HOME_PAGE_PREFIX_KEY}.volunteer`,
  `${HOME_PAGE_PREFIX_KEY}.volunteer.button`,
  `${HOME_PAGE_PREFIX_KEY}.partnership_and_licensing`,
  `${HOME_PAGE_PREFIX_KEY}.partnership_and_licensing.highlight`,
  `${HOME_PAGE_PREFIX_KEY}.site_pro`,
  `${HOME_PAGE_PREFIX_KEY}.site_pro.join_btn`,
  `${HOME_PAGE_PREFIX_KEY}.site_pro.search_link`,
  `${HOME_PAGE_PREFIX_KEY}.top_section.expert_image.1`,
  `${HOME_PAGE_PREFIX_KEY}.top_section.expert_image.2`,
  `${HOME_PAGE_PREFIX_KEY}.top_section.expert_image.3`,
  `${HOME_PAGE_PREFIX_KEY}.top_section.expert_image.4`,
  `${HOME_PAGE_PREFIX_KEY}.top_section.expert_image.5`,
  `${HOME_PAGE_PREFIX_KEY}.top_section.expert_image.6`,
  `${HOME_PAGE_PREFIX_KEY}.top_section.expert_image.7`,
  `${HOME_PAGE_PREFIX_KEY}.top_section.expert_image.8`,
  `${HOME_PAGE_PREFIX_KEY}.top_section.join_to_learn_button`,
  `${HOME_PAGE_PREFIX_KEY}.top_section.join_as_expert_button`,
  `${HOME_PAGE_PREFIX_KEY}.what_interests_you`,
];

export const JOIN_PAGE_KEYS = [
  `${JOIN_PAGE_PREFIX_KEY}.top_section`,
  `${JOIN_PAGE_PREFIX_KEY}.finding_expert.search_helper_text`,
];

export const SITE_PAGE_KEYS = [
  `${SITE_PAGE_PREFIX_KEY}.gain_access_section`,
  `${SITE_PAGE_PREFIX_KEY}.explain_left`,
  `${SITE_PAGE_PREFIX_KEY}.explain_right`,
  `${SITE_PAGE_PREFIX_KEY}.become_an_expert`,
  `${SITE_PAGE_PREFIX_KEY}.become_an_expert_header`,
  `${SITE_PAGE_PREFIX_KEY}.become_an_expert_button`,
  `${SITE_PAGE_PREFIX_KEY}.featured_experts_section`,
  `${SITE_PAGE_PREFIX_KEY}.featured_experts_section_1`,
  `${SITE_PAGE_PREFIX_KEY}.featured_experts_section_2`,
  `${SITE_PAGE_PREFIX_KEY}.featured_experts_section_3`,
  `${SITE_PAGE_PREFIX_KEY}.finding_expert.logo`,
  `${SITE_PAGE_PREFIX_KEY}.finding_expert.search_helper_text`,
  `${SITE_PAGE_PREFIX_KEY}.program_overview`,
];

export const JOIN_AS_EXPERT_KEYS = [
  `${JOIN_AS_EXPERT_PREFIX_KEY}.top_section.title`,
  `${JOIN_AS_EXPERT_PREFIX_KEY}.top_section.content`,
  `${JOIN_AS_EXPERT_PREFIX_KEY}.top_section.content.highlight_start`,
  `${JOIN_AS_EXPERT_PREFIX_KEY}.main_section.1.title`,
  `${JOIN_AS_EXPERT_PREFIX_KEY}.main_section.1.content`,
  `${JOIN_AS_EXPERT_PREFIX_KEY}.main_section.2.title`,
  `${JOIN_AS_EXPERT_PREFIX_KEY}.main_section.2.content`,
  `${JOIN_AS_EXPERT_PREFIX_KEY}.main_section.2.content.highlight_start`,
  `${JOIN_AS_EXPERT_PREFIX_KEY}.main_section.2.content.highlight_end`,
  `${JOIN_AS_EXPERT_PREFIX_KEY}.call_to_action`,
];

export const ABOUT_PAGE_KEYS = [
  `${ABOUT_PAGE_PREFIX_KEY}.blocks.1.title`,
  `${ABOUT_PAGE_PREFIX_KEY}.blocks.1.content`,
  `${ABOUT_PAGE_PREFIX_KEY}.blocks.1.content.highlight`,
  `${ABOUT_PAGE_PREFIX_KEY}.blocks.2.title`,
  `${ABOUT_PAGE_PREFIX_KEY}.blocks.2.content`,
  `${ABOUT_PAGE_PREFIX_KEY}.blocks.2.content.highlight`,
  `${ABOUT_PAGE_PREFIX_KEY}.blocks.3.title`,
  `${ABOUT_PAGE_PREFIX_KEY}.blocks.3.content`,
  `${ABOUT_PAGE_PREFIX_KEY}.blocks.3.content.highlight`,
  `${ABOUT_PAGE_PREFIX_KEY}.blocks.4.title`,
  `${ABOUT_PAGE_PREFIX_KEY}.blocks.4.content`,
  `${ABOUT_PAGE_PREFIX_KEY}.blocks.4.content.highlight`,
];

export const PARTNERSHIP_AND_LICENSING_PAGE_KEYS = [
  `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.1.title`,
  `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.1.content`,
  `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.1.content.highlight`,
  `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.2.title`,
  `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.2.content`,
  `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.2.content.highlight`,
  `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.3.title`,
  `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.3.content`,
  `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.3.content.highlight`,
  `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.4.title`,
  `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.4.content`,
  `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.4.content.highlight`,
];

export const mappedPartnershipAndLicensingPageKeys = [
  {
    title: `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.1.title`,
    content: `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.1.content`,
    contentHighlight: `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.1.content.highlight`,
  },
  {
    title: `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.2.title`,
    content: `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.2.content`,
    contentHighlight: `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.2.content.highlight`,
  },
  {
    title: `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.3.title`,
    content: `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.3.content`,
    contentHighlight: `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.3.content.highlight`,
  },
  {
    title: `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.4.title`,
    content: `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.4.content`,
    contentHighlight: `${PARTNERSHIP_AND_LICENSING_PAGE_PREFIX_KEY}.blocks.4.content.highlight`,
  },
];

export const VOLUNTEER_CONTENT_PAGE_KEYS = [
  `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.1.title`,
  `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.1.content`,
  `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.1.content.highlight`,
  `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.2.title`,
  `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.2.content`,
  `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.2.content.highlight`,
  `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.3.title`,
  `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.3.content`,
  `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.3.content.highlight`,
  `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.4.title`,
  `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.4.content`,
  `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.4.content.highlight`,
];

export const mappedVolunteerContentPageKeys = [
  {
    title: `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.1.title`,
    content: `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.1.content`,
    contentHighlight: `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.1.content.highlight`,
  },
  {
    title: `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.2.title`,
    content: `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.2.content`,
    contentHighlight: `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.2.content.highlight`,
  },
  {
    title: `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.3.title`,
    content: `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.3.content`,
    contentHighlight: `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.3.content.highlight`,
  },
  {
    title: `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.4.title`,
    content: `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.4.content`,
    contentHighlight: `${VOLUNTEER_CONTENT_PAGE_PREFIX_KEY}.blocks.4.content.highlight`,
  },
];

export const SUPPORTING_CHARITIES_PAGE_KEYS = [
  `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.1.title`,
  `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.1.content`,
  `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.1.content.highlight`,
  `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.2.title`,
  `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.2.content`,
  `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.2.content.highlight`,
  `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.3.title`,
  `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.3.content`,
  `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.3.content.highlight`,
  `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.4.title`,
  `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.4.content`,
  `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.4.content.highlight`,
];

export const mappedSupportingCharitiesPageKeys = [
  {
    title: `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.1.title`,
    content: `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.1.content`,
    contentHighlight: `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.1.content.highlight`,
  },
  {
    title: `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.2.title`,
    content: `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.2.content`,
    contentHighlight: `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.2.content.highlight`,
  },
  {
    title: `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.3.title`,
    content: `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.3.content`,
    contentHighlight: `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.3.content.highlight`,
  },
  {
    title: `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.4.title`,
    content: `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.4.content`,
    contentHighlight: `${SUPPORTING_CHARITIES_PAGE_PREFIX_KEY}.blocks.4.content.highlight`,
  },
];

export const NOTFOUND_PAGE_KEYS = [
  `${NOTFOUND_PAGE_PREFIX_KEY}.not_found.image`,
  `${NOTFOUND_PAGE_PREFIX_KEY}.not_found.content`,
];

export const mappedHrefTerms = {
  [`${TERM_OF_SERVICE_PREFIX_KEY}.acceptance_of_terms`]: ACCEPTANCE_OF_TERMS_HREF,
  [`${TERM_OF_SERVICE_PREFIX_KEY}.privacy`]: PRIVACY_HREF,
};

export const SIGN_UP_PAGE_KEYS = [
  `${SIGN_UP_PAGE_PREFIX_KEY}.header`,
  `${SIGN_UP_PAGE_PREFIX_KEY}.join_button`,
  `${SIGN_UP_PAGE_PREFIX_KEY}.expert_sign_up.header`,
  `${SIGN_UP_PAGE_PREFIX_KEY}.expert_sign_up.join_button`,
  `${SIGN_UP_PAGE_PREFIX_KEY}.success`,
];

export const HEADER_AND_FOOTER_KEYS = [
  `${HEADER_AND_FOOTER_PREFIX_KEY}.header.desktop.join_button`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.header.desktop.join_as_expert_button`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.header.mobile.join_button`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.header.mobile.join_as_expert_button`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.header.mobile.help`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.header.search_helper_text`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.header.sign_in_button`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.header.menu_popup`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.header.menu_popup.sidetime_select`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.facebook`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.instagram`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.twitter`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.linkedin`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.newsletter`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.about`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.faq`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.terms`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.privacy_policy`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.download_app`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.gift_cards`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.give_feedback`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.copyright`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.youtube`,
  `${HEADER_AND_FOOTER_PREFIX_KEY}.footer.newsletter.header`,
];

export const ACCOUNT_SETTINGS_KEYS = [
  `${ACCOUNT_SETTINGS_PREFIX_KEY}.terms_of_service`,
  `${ACCOUNT_SETTINGS_PREFIX_KEY}.payment_methods`,
];

export const EXPERT_SETTINGS_KEYS = [
  `${EXPERT_SETTINGS_PREFIX_KEY}.new_sessions`,
  `${EXPERT_SETTINGS_PREFIX_KEY}.recommend_new_areas_of_expertise.helper_text`,
];

export const ONBOARDING_PAGE_KEYS = [
  `${ONBOARDING_PAGE_PREFIX_KEY}.left_menu.subheader`,
  `${ONBOARDING_PAGE_PREFIX_KEY}.welcome_message`,
  `${ONBOARDING_PAGE_PREFIX_KEY}.founder-1`,
  `${ONBOARDING_PAGE_PREFIX_KEY}.founder-2`,
];

export const SEARCH_PAGE_KEYS = [`${SEARCH_PAGE_PREFIX_KEY}.search_term.helper_text`];
